import { REGISTER_USER, REGISTER_USER_SUCCESSFUL, REGISTER_USER_FAILED } from './actionTypes';

const initialState = {
    registrationError: null, message: null, loading: null
}

const account = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_USER:
            return {
                ...state,
                user: null,
                loading: true,
                registrationError: null
            }
       
        case REGISTER_USER_SUCCESSFUL:
            return {
                ...state,
                user: action.payload,
                loading: false,
                registrationError: null
            }
        case REGISTER_USER_FAILED:
            return {
                ...state,
                loading: false,
                registrationError: action.payload
            }
        default:
            return state ;
       
    }
}

export default account;